import Admin from "./admin";
import SuperAdmin from "./superAdmin";
import MarketingAdmin from "./marketingAdmin";

const Navigation = () => {
  // Destructure the array from components
  const { superAdminNavArray } = SuperAdmin();
  const { marketingAdminNavArray } = MarketingAdmin();
  const { adminNavArray } = Admin();

  const superAdminNav = superAdminNavArray;
  const marketingAdminNav = marketingAdminNavArray;
  const adminNav = adminNavArray;

  return { superAdminNav, marketingAdminNav, adminNav };
};

export default Navigation;
